import React from 'react';
import { withRouter } from 'react-router-dom';
import { SemanticContainer, SemanticSegment } from './styled';
import { Segment, Divider } from 'semantic-ui-react';
import AdminMenu from '../../../../../components/Admin/MenuDetalhes/AdminMenu';
import Back from '../../../../../components/Admin/Pocketbook/Cupons/Editar/Back';
import Formulario from '../../../../../components/Admin/Pocketbook/Cupons/Editar/Formulario';

const CuponsEdit = props => {
  return (
    <>
      <AdminMenu />
      <SemanticContainer>
        <Back />
        <h2>Editar Cupom</h2>
        <Divider />
        <Segment>
          <Formulario props={props} />
        </Segment>
      </SemanticContainer>
      <SemanticContainer>
        <SemanticSegment >
          Grupo Voitto <i class="copyright outline icon"></i>2021
        </SemanticSegment>
      </SemanticContainer>
    </>
  )
}

export default withRouter(CuponsEdit);
